export default __webpack_public_path__ + "static/media/mark.b884a837.jpg";